export default __webpack_public_path__ + "static/media/Nainital05.f173b7be.jpg";